// extracted by mini-css-extract-plugin
var _1 = "BirdviewTileRowCarousel-modulecarousel__RFHOY";
var _2 = "BirdviewTileRowCarousel-modulecarouselItem__GvqYH";
export { _1 as "carousel", _2 as "carouselItem" }
